/* eslint-disable react-hooks/exhaustive-deps */
// wijmo

// other
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Ajv, { ErrorObject } from "ajv"
import ajvErrors from "ajv-errors"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { Prompt, useHistory, useLocation, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { showInfoToast } from "../../../components/CustomToast"
import DateInput from "../../../components/InputWrapper/DateInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import TextInput from "../../../components/InputWrapper/TextInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import CONSTANT from "../../../constant"
import { 区分分類コード, 社員_乗務員 } from "../../../constant/enum/codes"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import {
  tekiseiSindanRegisterPostReqSchema,
  tekiseiSindanRegisterPutReqSchema,
} from "../../../service/driver/tekiseiSindan/tekiseiSindanScheme"
import TekiseiSindanService from "../../../service/driver/tekiseiSindan/tekiseiSindanService"
import {
  TTekiseiSindanPostReq,
  TTekiseiSindanPutReq,
  T適性診断,
} from "../../../service/driver/tekiseiSindan/TTekiseiSindan"
import KubunService from "../../../service/master/kubun/kubunService"
import { TApiResponse } from "../../../service/TApiResponse"
import stringUtil from "../../../ts/util/stringUtil"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { get乗務員 as get乗務員Inner } from "../../../ts/util/haisyaUtil"
import { TZyomuinListItem } from "../../../service/driver/TZyomuin"

export type T適性診断実施登録State = {
  乗務員ID?: number
}

/**
 * 適性診断実施登録
 * @returns
 */
const TekiseiSindanZissiRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined

  const 適性診断実施登録State = useLocation<T適性診断実施登録State>().state
  const zyomuinId = 適性診断実施登録State?.乗務員ID ?? undefined

  const 画面モード: "新規" | "実施登録新規" | "編集" =
    (id ?? 0) !== 0 ? "編集" : (zyomuinId ?? 0) !== 0 ? "実施登録新規" : "新規"

  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 初期表示管理用
  const [isComboboxItemInitialized, setIsComboboxItemInitialized] =
    useState<boolean>(false)

  // 表示項目のstate

  const [乗務員ID, set乗務員ID] = useState<number>()
  const [社員コード, set社員コード] = useState<string>()
  const [社員氏名, set社員氏名] = useState<string>()
  const [部所略称, set部所略称] = useState<string>()

  const [実施日, set実施日] = useState<string | null | undefined>()

  const [適性診断種類区分コード, set適性診断種類区分コード] = useState<
    string | null
  >()

  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [実施機関ItemSource] = useState([
    { name: "NASVA", value: "NASVA" },
    { name: "NASVAネット", value: "NASVAネット" },
  ])

  const [実施機関, set実施機関] = useState<string>("")
  const [判定結果1, set判定結果1] = useState<number>(0)
  const [判定結果2, set判定結果2] = useState<number>(0)
  const [判定結果3, set判定結果3] = useState<number>(0)
  const [判定結果4, set判定結果4] = useState<number>(0)
  const [判定結果5, set判定結果5] = useState<number>(0)
  const [判定結果6, set判定結果6] = useState<number>(0)
  const [判定結果7, set判定結果7] = useState<number>(0)
  const [判定結果8, set判定結果8] = useState<number>(0)
  const [判定結果9, set判定結果9] = useState<number>(0)
  const [判定結果10, set判定結果10] = useState<number>(0)

  const 判定結果Radio行生成用List = [
    { number: 1, kbnCode: "1", setter: set判定結果1, getter: 判定結果1 },
    { number: 2, kbnCode: "2", setter: set判定結果2, getter: 判定結果2 },
    { number: 3, kbnCode: "3", setter: set判定結果3, getter: 判定結果3 },
    { number: 4, kbnCode: "4", setter: set判定結果4, getter: 判定結果4 },
    { number: 5, kbnCode: "5", setter: set判定結果5, getter: 判定結果5 },
    { number: 6, kbnCode: "6", setter: set判定結果6, getter: 判定結果6 },
    { number: 7, kbnCode: "7", setter: set判定結果7, getter: 判定結果7 },
    { number: 8, kbnCode: "8", setter: set判定結果8, getter: 判定結果8 },
    { number: 9, kbnCode: "9", setter: set判定結果9, getter: 判定結果9 },
    { number: 10, kbnCode: "10", setter: set判定結果10, getter: 判定結果10 },
  ]
  const 判定結果値List = [
    { name: "良", value: 0 },
    { name: "否", value: 1 },
  ]

  const [所見, set所見] = useState<string>("")

  const [更新対象実施データ, set更新対象実施データ] = useState<T適性診断>()

  //#region [comboboxState]

  // 実施機関ComboBox
  const [実施機関ComboBox, set実施機関ComboBox] = useState<TWijmoComboBox<
    string,
    { name: string; value: string }
  > | null>(null)
  const [実施機関isLoadEnded, set実施機関isLoadEnded] = useState<boolean>(false)

  // 適性診断種類区分
  const [適性診断種類区分ComboBox, set適性診断種類区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [適性診断種類区分isLoadEnded, set適性診断種類区分isLoadEnded] =
    useState<boolean>(false)

  //　エラー表示用フラグ
  const [isInvalid乗務員, setIsInvalid乗務員] = useState<boolean>(false)
  const [isInvalid実施日, setIsInvalid実施日] = useState<boolean>()
  const [isInvalid適性診断種類区分コード, setIsInvalid適性診断種類区分コード] =
    useState<boolean>(false)
  const [isInvalid実施機関, setIsInvalid実施機関] = useState<boolean>(false)
  const [isInvalid所見, setIsInvalid所見] = useState<boolean>(false)

  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  //#endregion

  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isDeleteConfirmModalShow, setIsDeleteConfirmModalShow] =
    useState(false)

  //#endregion

  //#region [method]

  const get教育内容ラベル = (
    区分List: T区分マスタ[],
    区分コード: string
  ): string => {
    if (区分List == null) return ""
    const 対象区分 = 区分List.find(
      (k) =>
        k.分類コード === 社員_乗務員.適性診断判定結果区分 &&
        k.区分コード === 区分コード
    )
    return 対象区分?.名称1 ?? ""
  }

  /**
   * 実施登録一覧情報取得
   */
  const get実施登録一覧情報 = async (zyomuinId: number) => {
    const service = new TekiseiSindanService()

    try {
      const res = await service.getList({ 乗務員ID: zyomuinId })
      if (res.data.length === 0) {
        disPatch(setWarningAlerts(["既に更新または削除されたデータです。"]))
        return false
      } else {
        const firstData = res.data[0]
        set乗務員ID(firstData.乗務員ID)
        set社員コード(firstData.社員コード)
        set社員氏名(firstData.社員氏名)
        set部所略称(firstData.部所略称)
        set適性診断種類区分コード(firstData.次回適正種類区分コード)
        return true
      }
    } catch (error) {
      disPatch(setAlerts(error))
      return false
    }
  }

  /**
   * 適性診断情報取得
   */
  const get適性診断情報 = async () => {
    const service = new TekiseiSindanService()

    try {
      const res = await service.get(id!)
      if (res.data) {
        set乗務員ID(res.data.乗務員ID)
        set社員コード(res.data.社員コード)
        set社員氏名(res.data.社員氏名)
        set部所略称(res.data.部所略称)
        set実施日(res.data.実施日)
        set実施機関(res.data.実施機関)
        set適性診断種類区分コード(res.data.適性診断種類区分コード)
        set判定結果1(res.data.判定結果1)
        set判定結果2(res.data.判定結果2)
        set判定結果3(res.data.判定結果3)
        set判定結果4(res.data.判定結果4)
        set判定結果5(res.data.判定結果5)
        set判定結果6(res.data.判定結果6)
        set判定結果7(res.data.判定結果7)
        set判定結果8(res.data.判定結果8)
        set判定結果9(res.data.判定結果9)
        set判定結果10(res.data.判定結果10)
        set所見(res.data.所見)

        set更新対象実施データ(res.data)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 乗務員フォーカスアウト時の動き
   */
  const get乗務員 = async (乗務員コード: string) => {
    try {
      return get乗務員Inner(乗務員コード)
    } catch (error) {
      disPatch(setAlerts(error))
    }
    return
  }

  const apply乗務員 = (乗務員?: TZyomuinListItem) => {
    if (乗務員 == null) {
      set乗務員ID(undefined)
      set社員コード("")
      set社員氏名("")
      set部所略称("")
    } else {
      set乗務員ID(乗務員.乗務員ID)
      set社員コード(乗務員.社員コード)
      set社員氏名(乗務員.社員氏名)
      set部所略称(乗務員.部所略称)
    }
  }

  const getPostReq = (): TTekiseiSindanPostReq => {
    return {
      乗務員ID: 乗務員ID!,
      実施日: 実施日 != null ? 実施日 : "",
      適性診断種類区分コード:
        適性診断種類区分コード != null ? 適性診断種類区分コード : "",
      実施機関: 実施機関 ?? "",
      所見: 所見 ?? "",
      判定結果1: 判定結果1,
      判定結果2: 判定結果2,
      判定結果3: 判定結果3,
      判定結果4: 判定結果4,
      判定結果5: 判定結果5,
      判定結果6: 判定結果6,
      判定結果7: 判定結果7,
      判定結果8: 判定結果8,
      判定結果9: 判定結果9,
      判定結果10: 判定結果10,
    }
  }

  const getPutReq = (): TTekiseiSindanPutReq => {
    return {
      乗務員ID: 乗務員ID!,
      実施日: 実施日 != null ? 実施日 : "",
      適性診断種類区分コード:
        適性診断種類区分コード != null ? 適性診断種類区分コード : "",
      実施機関: 実施機関 ?? "",
      所見: 所見 ?? "",
      判定結果1: 判定結果1,
      判定結果2: 判定結果2,
      判定結果3: 判定結果3,
      判定結果4: 判定結果4,
      判定結果5: 判定結果5,
      判定結果6: 判定結果6,
      判定結果7: 判定結果7,
      判定結果8: 判定結果8,
      判定結果9: 判定結果9,
      判定結果10: 判定結果10,
      更新日時: 更新対象実施データ!.更新日時,
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    let schema
    let data
    if (画面モード === "編集") {
      data = getPutReq()
      schema = tekiseiSindanRegisterPutReqSchema
    } else {
      data = getPostReq()
      schema = tekiseiSindanRegisterPostReqSchema
    }
    const validate = ajv.compile(schema)
    const validateResult = validate(data)
    if (!validateResult) {
      const errors = validate.errors

      if (errors != null && errors.length > 0) {
        //エラーメッセージのparamsより対象の項目を発見し色変え
        setValidateError(errors)
        disPatch(
          setWarningAlerts([
            ...errors
              .filter((e) => e.message != null)
              .map((e) => e.message ?? ""),
          ])
        )
      }
      return
    }

    setIsConfirmModalShow(true)
  }

  /**
   * エラー発生時の項目色変え
   * @param errors
   */
  const setValidateError = (
    errors: ErrorObject<string, Record<string, any>, unknown>[]
  ) => {
    const instancePaths = errors.map((e) => e.instancePath.replaceAll("/", ""))
    const requiredProperties = errors
      .filter(
        (e) =>
          e.instancePath === "" &&
          e.params.errors.length > 0 &&
          e.params.errors.find(
            (ec: { keyword: string }) => ec.keyword === "required"
          )
      )
      .map((e) => {
        const error = e.params.errors[0]
        return error.params.missingProperty
      })
    const errorProperties = [...instancePaths, ...requiredProperties]

    setIsInvalid乗務員(errorProperties.includes("乗務員ID"))
    setIsInvalid実施日(errorProperties.includes("実施日"))
    setIsInvalid適性診断種類区分コード(
      errorProperties.includes("適性診断種類区分コード")
    )
    setIsInvalid実施機関(errorProperties.includes("実施機関"))
    setIsInvalid所見(errorProperties.includes("所見"))
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new TekiseiSindanService()
      let res: TApiResponse<boolean>
      if (画面モード === "編集") {
        res = await service.put(
          更新対象実施データ!.乗務員適性診断ID,
          getPutReq()
        )
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(
          `適性診断の${画面モード === "編集" ? "更新" : "登録"}が完了しました`
        )
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 削除
   */
  const deleteData = async () => {
    if (更新対象実施データ == null) return
    try {
      const service = new TekiseiSindanService()
      const res = await service.delete(
        更新対象実施データ.乗務員適性診断ID,
        更新対象実施データ.更新日時
      )
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`定期診断を削除しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }
  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    // 区分取得
    Promise.all([new KubunService().getList()])
      .then(([区分マスタRes]) => {
        区分マスタRes && set区分ItemSource(区分マスタRes.data)
      })
      .catch((err) => {
        disPatch(setAlerts(err))
      })
  }, [])

  // ComboBox完成待機
  useEffect(() => {
    if (!適性診断種類区分isLoadEnded) return
    if (!実施機関isLoadEnded) return

    setIsComboboxItemInitialized(true)
  }, [適性診断種類区分isLoadEnded, 実施機関isLoadEnded])

  useEffect(() => {
    if (!isComboboxItemInitialized) return

    // 画面モードごとのデータ取得処理
    switch (画面モード) {
      case "新規":
        disPatch(画面ロック解除())
        // ファイルロード後、戻るボタン押下時に警告が出るように変更
        isPrompt.current = true
        break
      case "実施登録新規":
        get実施登録一覧情報(zyomuinId!).finally(() => {
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = true
        })
        break
      case "編集":
        get適性診断情報().finally(() => {
          disPatch(画面ロック解除())
          // ファイルロード後、戻るボタン押下時に警告が出るように変更
          isPrompt.current = true
        })
        break
    }
  }, [isComboboxItemInitialized])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">
              適性診断実施{画面モード === "編集" ? `更新` : `登録`}
            </span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card className="w-60rem">
              <Card.Body>
                <Container fluid className="register-form">
                  <MasterRegisterFormRow label="乗務員" isRequired={true}>
                    <TextInput
                      autoFocus={画面モード === "新規"}
                      id="社員コード"
                      name="社員コード"
                      isReadOnly={画面モード !== "新規"}
                      value={社員コード}
                      setValue={set社員コード}
                      maxLength={4}
                      className={
                        "w-4rem " + (isInvalid乗務員 ? "is-error" : "")
                      }
                      onBlur={async (e) => {
                        if (!stringUtil.isNullOrWhiteSpace(社員コード)) {
                          const inner乗務員 = await get乗務員(社員コード!)
                          apply乗務員(inner乗務員)
                        } else {
                          apply乗務員(undefined)
                        }
                      }}
                    />
                    <button
                      type="button"
                      className="icon-button"
                      disabled={画面モード !== "新規"}>
                      <a
                        href="*"
                        onClick={(e) => {
                          e.preventDefault()
                          setIs乗務員検索Modal(true)
                        }}>
                        <FontAwesomeIcon
                          className="icon-button-inner"
                          icon={faSearch}></FontAwesomeIcon>
                      </a>
                    </button>
                    <TextInput
                      id="社員氏名"
                      name="社員氏名"
                      isReadOnly={true}
                      value={社員氏名}
                      setValue={set社員氏名}
                      maxLength={100}
                    />
                  </MasterRegisterFormRow>
                  {/* 部所 */}
                  <MasterRegisterFormRow label="部所" isRequired={false}>
                    <TextInput
                      id="部所略称"
                      name="部所略称"
                      isReadOnly={true}
                      value={部所略称}
                      setValue={set部所略称}
                      maxLength={100}
                    />
                  </MasterRegisterFormRow>
                  {/* 種類 */}
                  <MasterRegisterFormRow label="適性診断種類" isRequired={true}>
                    <ComboBox.Kubun
                      autoFocus={画面モード === "編集"}
                      placeholder="適性診断種類"
                      分類コード={区分分類コード.社員_乗務員.適性診断種類区分}
                      isReadOnly={画面モード === "実施登録新規"}
                      isUnselectStart={true}
                      isRequired={false}
                      itemsSource={区分ItemSource}
                      isLoadEnded={適性診断種類区分isLoadEnded}
                      setIsLoadEnded={set適性診断種類区分isLoadEnded}
                      selectedValue={適性診断種類区分コード}
                      setSelectedValue={(v) => {
                        set適性診断種類区分コード(v)
                      }}
                      ComboBox={適性診断種類区分ComboBox}
                      setComboBox={set適性診断種類区分ComboBox}
                      className={
                        isInvalid適性診断種類区分コード ? "is-error" : ""
                      }></ComboBox.Kubun>
                  </MasterRegisterFormRow>
                  {/* 実施機関 */}
                  <MasterRegisterFormRow label="実施機関" isRequired={true}>
                    <ComboBox.Default
                      autoFocus={画面モード === "実施登録新規"}
                      placeholder="実施機関"
                      isLoadEnded={実施機関isLoadEnded}
                      setIsLoadEnded={set実施機関isLoadEnded}
                      isRequired={false}
                      isUnselectStart={true}
                      selectedValue={実施機関}
                      setSelectedValue={(v) => {
                        set実施機関(v)
                      }}
                      itemsSource={実施機関ItemSource}
                      displayTextFormatter={(item) => item.name}
                      ComboBox={実施機関ComboBox}
                      setComboBox={set実施機関ComboBox}
                      className={
                        isInvalid実施機関 ? "is-error" : ""
                      }></ComboBox.Default>
                  </MasterRegisterFormRow>
                  {/* 実施日 */}
                  <MasterRegisterFormRow label="実施日" isRequired={true}>
                    <DateInput
                      id="実施日"
                      placeholder="実施日"
                      value={実施日}
                      setValue={(v) => {
                        set実施日(v)
                      }}
                      className={isInvalid実施日 ? "is-error" : ""}></DateInput>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
            <Card className="w-60rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 判定結果 */}
                  <Table className="form-table-label-left table-bordered">
                    <thead>
                      <tr>
                        <th className="text-center">No</th>
                        <th>教育内容</th>
                        {/* 判定結果値TH作成ループ */}
                        {判定結果値List.map((判定結果値Item) => (
                          <th
                            key={`th_${判定結果値Item.value}`}
                            className="text-center">
                            {判定結果値Item.name}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* 判定結果Radio行作成ループ */}
                      {判定結果Radio行生成用List.map((src) => (
                        <tr key={`tr_${src.number}`}>
                          <th
                            key={`tr_${src.number}_th_No`}
                            className="text-center">
                            {src.number}
                          </th>
                          <th key={`tr_${src.number}_th_教育内容`}>
                            {get教育内容ラベル(
                              区分ItemSource ?? [],
                              src.kbnCode
                            )}
                          </th>
                          {/* 判定結果値TD作成ループ */}
                          {判定結果値List.map((判定結果値Item) => (
                            <td
                              key={`tr_${src.number}_td_${判定結果値Item.value}`}
                              onClick={() => {
                                src.setter(判定結果値Item.value)
                              }}>
                              <Form.Check
                                id={`判定結果${src.number}_${判定結果値Item.value}`}
                                type="radio"
                                name={`判定結果${src.number}`}
                                key={判定結果値Item.value}
                                value={判定結果値Item.value}
                                className="d-flex align-items-center justify-content-center h-100 w-5rem"
                                checked={src.getter === 判定結果値Item.value}
                                onChange={() => {
                                  src.setter(判定結果値Item.value)
                                }}></Form.Check>
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Container>
              </Card.Body>
            </Card>
            <Card className="w-60rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 所見 */}
                  <MasterRegisterFormRow label="総合所見" isRequired={false}>
                    <TextAreaInput
                      id="所見"
                      name="所見"
                      value={所見}
                      setValue={set所見}
                      placeholder="総合所見"
                      className={isInvalid所見 ? "is-error" : ""}
                    />
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {画面モード === "編集" ? `更新` : `登録`}
            </Button>
            <Button
              size="lg"
              className="ms-2"
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
            {画面モード === "編集" && (
              <Button
                size="lg"
                className="ms-5"
                variant="caution"
                onClick={(e) => {
                  e.stopPropagation()
                  e.preventDefault()
                  setIsDeleteConfirmModalShow(true)
                }}>
                削除
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で{画面モード === "編集" ? "更新" : "登録"}しますか？
      </ConfirmModal>
      <ConfirmModal
        isShow={isDeleteConfirmModalShow}
        hideHandler={setIsDeleteConfirmModalShow}
        submitHandler={deleteData}>
        入力された内容で削除しますか？
      </ConfirmModal>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        setZyomuin={(乗務員) => {
          apply乗務員(乗務員)
        }}></ZyomuinSearchModal>
    </>
  )
}

export default TekiseiSindanZissiRegister
